/*
 * Service customerInfoFilter
 */
angular
  .module('posApp')
  .factory('customerInfoFilter', (customerInfoFilterOptions) => {
    const customerInfoFilter: any = {};

    customerInfoFilter.year = null;
    customerInfoFilter.month = null;
    customerInfoFilter.warehouseId;
    customerInfoFilter.combined = customerInfoFilterOptions[1];

    return customerInfoFilter;
  });
